<template>
  <div :class="$style['ai-member']">
    <div :class="[$style['intro'], $style['section']]">
      <ComTitle>
        {{ data.intro.title.word }}
      </ComTitle>

      <div :class="$style['layout-content']">
        <div
          :class="[$style['desc'], introMore ? $style['is-more'] : '']"
          v-for="(p, index) in introMore ? data.intro.content : data.intro.content.slice(0, 1)"
          :key="index"
        >
          {{ p }}
        </div>
      </div>

      <!-- <div :class="$style['more-wrap']" @click="scanMore" v-if="!introMore">
        <span :class="$style['more']">查看更多</span>
        <i class="iconfont">&#xe604;</i>
      </div> -->
    </div>

    <div :class="[$style['model']]">
      <ComTitle>
        {{ data.model.title.word }}
      </ComTitle>

      <div :class="$style['layout-content']">
        <img
          :src="img"
          v-for="(img, index) in data.model.content"
          :key="`model-${index}`"
        >
      </div>
    </div>

      <Question
        :info="data.question"
      />

    <transition name="fade">
      <div :class="$style['fix-member']" v-if="fixMember">
        <div :class="$style['layout-content']">
          <h2 :class="$style['title']">AI 会员<br/>暖冬计划</h2>
          <div :class="$style['fix-member-content']">
            <div
              :class="$style['fix-member-item']"
              v-for="(item, index) in data.fixMember.content"
              :key="`fix-${index}`"
            >
              <div :class="$style['fix-member-item-title']">
                <img :src="item.icon" :class="$style['icon']">
                {{ item.title }}
              </div>

              <div :class="$style['btn']" @click="goJoin(item)">
                立即加入
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <gkModal
      gkmodal-color="com"
      :value="modalVisible"
      v-model="modalVisible"
      :maskClickClose="true"
      transition="gk-fade-up"
      :needClose="false"
      loading
      @close="closeModal"
    >
      <div :class="$style['modal-title']">极客俱乐部</div>

      <div :class="$style['qrcode']">
        <img src="https://static001.geekbang.org/resource/image/28/2d/281e5266759546ec818ff3baf5dc232d.png">
      </div>

      <p :class="$style['desc']">扫码添加极客俱乐部小助手<br/>咨询更多详情</p>

      <div :class="$style['modal-close']" @click="closeModal">
        <img src="https://static001.geekbang.org/resource/image/45/11/45e48f497b9b81cbdc1cba8bb8e5ea11.png">
      </div>

      <div slot="footer"></div>
    </gkModal>
  </div>
</template>

<script>
import gkModal from 'gkSrc/v2/modal'
import ComTitle from './Title.vue'
import Question from './Question.vue'
// import ComModal from '@/components/modal/ComModal'

import { getAIMemberData } from './data'

export default {
  name: 'AIMemberWap',

  data () {
    return {
      fixMember: false,

      modalVisible: false,

      introMore: false
    }
  },

  components: {
    gkModal,
    Question,
    ComTitle

    // ComModal
  },

  computed: {
    data () {
      return getAIMemberData(true)
    }
  },

  mounted () {
    window.addEventListener('scroll', this.handleScroll)

    // setTimeout(() => {
    //   this.modalVisible = true
    // })
  },

  methods: {
    handleScroll () {
      this.fixMember = window.scrollY > 382
    },

    scanMore () {
      this.introMore = true
    },

    goJoin (item) {
      if (item.jumpType === 'modal') {
        this.showModal()

        return
      }

      window.open(item.url)
    },

    showModal () {
      this.modalVisible = true
    },

    closeModal () {
      this.modalVisible = false
    }
  }
}
</script>

<style lang="scss" module>
@import './base.scss';
@import '~@geekbang/geek.ui/src/v2/modal/base';

.ai-member {
  background:
    url(https://static001.geekbang.org/resource/image/22/2a/22ca06f4bef0368251e73521f3a7492a.png) top 0 left 0 / 100vw auto no-repeat,
    linear-gradient(180deg, rgba(253,197,146,0.59) 0%, rgba(255,255,255,0) 530px)
  ;
}

.intro {
  padding-top: 60px;
  .layout-content {
    margin-top: 22px;
    color: #6B4831;
    font-size: 14px;
    line-height: 25px;
  }

  .desc {
    @include limit-line-numbers(8);

    &.is-more {
      display: block;
    }

    &:last-child {
      margin-top: 20px;
    }
  }

  // .more-wrap {
  //   width: calc(100vw - 40px);
  //   margin: 0 auto;
  //   color: #FF5700;
  //   // text-align: right;
  //   font-size: 14px;
  // }
}

.model {
  .layout-content {
    width: calc(100vw - 14px);
    margin-top: 30px;
    padding-bottom: 48px;

    img {
      vertical-align: middle;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.fix-member {
  display: flex; align-items: center;
  position: fixed; top: 48px; left: 0; right: 0;
  height: 77px;
  background: #FFFFFF;
  box-shadow: 0px 9px 23px 0px rgba(254,234,210,0.7);
  z-index: 1;
  .layout-content {
    width: calc(100vw - 14px);
    display: flex; align-items: center; justify-content: space-between;
    // gap: 30px;
  }

  .title {
    width: 110 / 355 * 100%;
    font-weight: 600;
    font-size: 12px;
    color: #6B4831;
    text-align: center;
  }

  .fix-member-content {
    display: flex;
    flex:1;
    // gap: 25px;
  }

  .fix-member-item {
    flex: 1;
    display: flex; align-items: center; flex-direction: column;
  }

  .fix-member-item-title {
    display: flex; align-items: center;
    margin-bottom: 10px;

    font-weight: 500;
    font-size: 9px;
    color: #353535;
    white-space: nowrap;
    line-height: 14px;
  }

  .icon {
    width: 14px;
    margin-right: 2px;
    margin-top: -2px;
  }

  .btn {
    width: 66px;
    height: 22px;
    background: linear-gradient( 283deg, #F7B43E 0%, #F27F2A 100%);
    box-shadow: 0px 2px 16px 0px rgba(189,102,49,0.5);
    border-radius: 27px;

    font-weight: 500;
    font-size: 8.72px;
    color: #FFFFFF;
    line-height: 22px;
    text-align: center;
    cursor: pointer;
  }
}

@include appendGkModalColor('com') {
  & [gk-modal-main] {
    box-sizing: border-box;
    width: 320px;
    padding-bottom: 41px;
    border-radius: 10px;
    background:
      url(https://static001.geekbang.org/resource/image/f8/37/f8f4cb6ab6ef27a6a76a56498da35137.png) top 0 left 0 / 100% auto no-repeat
    ;
    text-align: center;

    @include mobile {
      top: 25%;
    }

    .modal-title {
      padding-top: 40px;
      font-weight: 600;
      font-size: 24px;
      color: #FFFFFF;
      line-height: 33px;
    }

    .qrcode {
      width: 152px; height: 152px;
      margin: 52px auto 8px;
      padding: 12px;
      background: #FFFFFF;
      border-radius: 7px;
    }

    .desc {
      font-weight: 400;
      font-size: 14px;
      color: #6C6C6C;
      line-height: 20px;
    }

    .modal-close {
      position: absolute; left: 50%; transform: translateX(-50%); bottom: -54px;
      width: 30px;
      cursor: pointer;
    }
  }
}
</style>
